import { ROLES } from "../../utils/rbacHelper";

export const USER_ROLE_ROUTE_CONFIG = [
  {
    key: "manager",
    label: "Manager",
    role: ROLES.MANAGER,
    path: "/users/manager",
    pageTitle: "Manager Users",
    pageSubtitle: "Manage manager accounts, hierarchy and access",
    addLabel: "Add Manager",
    pluralLabel: "Managers",
  },
  {
    key: "office-employee",
    label: "Office Employee",
    role: ROLES.OFFICE_EMPLOYEE,
    path: "/users/office-employee",
    pageTitle: "Office Employee Users",
    pageSubtitle: "Manage office employee accounts and permissions",
    addLabel: "Add Office Employee",
    pluralLabel: "Office Employees",
  },
  {
    key: "field-employee",
    label: "Field Employee",
    role: ROLES.FIELD_EMPLOYEE,
    path: "/users/field-employee",
    pageTitle: "Field Employee Users",
    pageSubtitle: "Manage field employee accounts, assignments and access",
    addLabel: "Add Field Employee",
    pluralLabel: "Field Employees",
  },
  {
    key: "sub-admin",
    label: "Sub Admin",
    role: ROLES.SUB_ADMIN,
    path: "/users/sub-admin",
    pageTitle: "Sub Admin Users",
    pageSubtitle: "Manage sub-admin accounts, permissions and access",
    addLabel: "Add Sub Admin",
    pluralLabel: "Sub Admins",
  },
  {
    key: "dealer",
    label: "Dealer",
    role: ROLES.DEALER,
    path: "/users/dealer",
    pageTitle: "Dealer Users",
    pageSubtitle: "Manage dealer accounts, hierarchy and activity",
    addLabel: "Add Dealer",
    pluralLabel: "Dealers",
  },
  {
    key: "driver",
    label: "Driver",
    role: ROLES.DRIVER,
    path: "/users/driver",
    pageTitle: "Driver Users",
    pageSubtitle: "Manage driver accounts, assignments and access",
    addLabel: "Add Driver",
    pluralLabel: "Drivers",
  },
  {
    key: "viewer",
    label: "Viewer",
    role: ROLES.VIEWER,
    path: "/users/viewer",
    pageTitle: "Viewer Users",
    pageSubtitle: "Manage viewer accounts and shared visibility access",
    addLabel: "Add Viewer",
    pluralLabel: "Viewers",
  },
  {
    key: "user",
    label: "User",
    role: ROLES.USER,
    path: "/users/user",
    pageTitle: "User Accounts",
    pageSubtitle: "Manage standard user accounts and access settings",
    addLabel: "Add User",
    pluralLabel: "Users",
  },
];

export const DEFAULT_USER_ROLE_SECTION = USER_ROLE_ROUTE_CONFIG[0].key;

export const findUserRoleConfig = (section) =>
  USER_ROLE_ROUTE_CONFIG.find((item) => item.key === section) || USER_ROLE_ROUTE_CONFIG[0];
